import { Select as MaterialSelect } from '@mui/material'

const Select = MaterialSelect

export { Select }
